import { MaskLines, FadeIn } from "./Reveal";

// Interior page hero — consistent editorial header
export const PageHero = ({ overline, title, subtitle }) => {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className="relative pt-40 md:pt-52 pb-16 md:pb-24 bg-ink overflow-hidden">
      <div className="grid-lines absolute inset-0 opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-ink" />
      <div className="container-x relative z-10">
        <FadeIn delay={0.1}>
          <div className="mb-6">
            <p className="overline">{overline}</p>
          </div>
        </FadeIn>
        <h1 className="font-heading font-bold uppercase tracking-tighter leading-[0.9] text-textmain text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
          <MaskLines startDelay={0.2} lines={lines} />
        </h1>
        {subtitle && (
          <FadeIn delay={0.6}>
            <p className="mt-8 max-w-2xl text-textmuted text-base md:text-lg leading-relaxed">
              {subtitle}
            </p>
          </FadeIn>
        )}
      </div>
    </section>
  );
};
